/* Glow Vibe — promo rotation + mobile sticky add-to-cart */
(function () {
  function init() {
    /* ---- rotating promo messages ---- */
    var msgs = document.querySelectorAll('.gv-promo__msg');
    if (msgs.length === 1) {
      msgs[0].classList.add('is-active');
    } else if (msgs.length > 1) {
      var i = 0;
      msgs[i].classList.add('is-active');
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 3800);
    }

    /* ---- mobile sticky add-to-cart ---- */
    var submit = document.querySelector('.product-form__submit');
    if (!submit) return;

    var titleEl = document.querySelector('.product__title h1, .product__title');
    var priceEl = document.querySelector(
      '.price__container .price-item--sale, .price__container .price-item--regular, .price .price-item'
    );

    var bar = document.createElement('div');
    bar.className = 'gv-sticky-atc';

    var info = document.createElement('div');
    info.className = 'gv-sticky-atc__info';

    var name = document.createElement('span');
    name.className = 'gv-sticky-atc__name';
    name.textContent = titleEl ? titleEl.textContent.trim() : document.title;
    info.appendChild(name);

    if (priceEl) {
      var price = document.createElement('span');
      price.className = 'gv-sticky-atc__price';
      price.textContent = priceEl.textContent.trim();
      info.appendChild(price);
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gv-sticky-atc__btn';
    btn.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
    btn.addEventListener('click', function () { submit.click(); });

    bar.appendChild(info);
    bar.appendChild(btn);
    document.body.appendChild(bar);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
        });
      }, { threshold: 0 });
      io.observe(submit);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
